import { render, staticRenderFns } from "./TapesMaterialEdit.vue?vue&type=template&id=ce4a8bf8&"
import script from "./TapesMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./TapesMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports